import axios from 'axios'
import {EntityDto} from '../../../../../../../services/dto/entityDto'
import {PagedResultDto} from '../../../../../../../services/dto/pagedResultDto'
import {PagedGraduatedCardResultRequestDto} from './dto/PagedGraduatedCardResultRequestDto'
import CreateGraduatedCard from './dto/CreateGraduatedCard'
import GetAllGraduatedCards from './dto/GetAllGraduatedCards'
import UpdateGraduatedCard from './dto/UpdateGraduatedCard'
import GetGraduatedCard from './dto/GetGraduatedCard'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Card/Create`
export const URL_DELETE = `${API_URL}/Card/Delete`
export const URL_GET = `${API_URL}/Card/Get`
export const URL_GET_ALL = `${API_URL}/Card/GetPagedAll`
export const URL_GET_BY_GRADUATED_ID = `${API_URL}/Card/GetByGraduatedId`
export const URL_UPDATE = `${API_URL}/Card/Update`
export const URL_UPDATE_STATUS = `${API_URL}/Card/UpdateCardStatus`
export const URL_GET_BY_USER_ID = `${API_URL}/Card/GetByGraduatedId`

export function onCreateGraduatedCard(createGraduatedCard: CreateGraduatedCard): Promise<boolean> {
  return axios.post(URL_CREATE, createGraduatedCard)
}

export function onDeleteGraduatedCard(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetGraduatedCardsByGraduationId(user: EntityDto): Promise<GetGraduatedCard> {
  return axios.get(URL_GET_BY_USER_ID, {params: user})
}

export function onGetGraduatedCard(entityDto: EntityDto): Promise<GetGraduatedCard> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllGraduatedCards(
  pagedFilterAndSortedRequest: PagedGraduatedCardResultRequestDto
): Promise<PagedResultDto<GetAllGraduatedCards>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onGetGraduatedCardByGraduatedId(
  graduated: EntityDto
): Promise<GetAllGraduatedCards> {
  return axios.get(URL_GET_BY_GRADUATED_ID, {params: graduated})
}

export function onUpdateGraduatedCard(
  updateGraduatedCardInput: UpdateGraduatedCard
): Promise<boolean> {
  return axios.put(URL_UPDATE, updateGraduatedCardInput)
}

export function onUpdateGraduatedCardStatus(
  updateGraduatedCardInput: UpdateGraduatedCard
): Promise<boolean> {
  return axios.put(URL_UPDATE_STATUS, updateGraduatedCardInput)
}
